import React from "react"
import { createStackNavigator } from "@react-navigation/stack"
import ScreenHeader from "../../utility/ScreenHeader"
import Settings from "../../settings/settings"
import ManageDemographics from "../../settings/manage-demographics"
import ManageAccounts from "../../settings/manage-accounts"
import ManageMfa from "../../settings/manage-mfa"
import InstitutionDetails from "../../settings/institution-details"

const Stack = createStackNavigator<any>()

const SettingsStack = () => {
  return (
    <Stack.Navigator
      id={undefined}
      screenOptions={{
        header: function SettingsHeader({ options, route }: any) {
          return (
            <ScreenHeader
              title={options.title || "Settings"}
              goBackEnabled={true}
              functionality={
                route.name === 'ManageAccounts'
                  ? 'add-account'
                  : route.name === 'InstitutionDetails'
                    ? 'institution-actions'
                    : undefined
              }
            />
          )
        },
        gestureEnabled: false
      }}
      initialRouteName='SettingsHome'
    >
      <Stack.Screen
        name="SettingsHome"
        component={Settings}
        options={{
          title: 'Settings',
        }}
      />
      <Stack.Screen
        name="ManageDemographics"
        component={ManageDemographics}
        options={{
          title: 'Manage Demographics',
        }}
      />
      <Stack.Screen
        name="ManageAccounts"
        component={ManageAccounts}
        options={{
          title: 'Manage Accounts',
        }}
      />
      <Stack.Screen
        name="InstitutionDetails"
        component={InstitutionDetails}
        options={{
          title: 'Institution',
        }}
      />
      <Stack.Screen
        name="ManageMfa"
        component={ManageMfa}
        options={{
          title: 'Manage MFA',
        }}
      />
    </Stack.Navigator>
  )
}

export default SettingsStack


